<template>
    <adaptive-modal
        name="delivery-project-details"
        :hide-action-buttons="true"
        @before-open="beforeOpen"
    >
        <span v-if="deliveryProject">
            <strong>Leveransprojekt:</strong> {{ deliveryProject.name }}
        </span>
    </adaptive-modal>
</template>
<script>
    export default {
        data() {
            return {
                deliveryProject: null,
            };
        },
        methods: {
            beforeOpen(obj) {
                this.deliveryProject = obj.params;
            },
        },
    };
</script>
